import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useOutsideClick, Stack as Stack$1, Box as Box$1, HStack, Table as Table$1, Thead, Tr, Th, Text, TableCaption, Tbody, Td, Popover, PopoverTrigger, Button as Button$1, Portal, PopoverContent, PopoverArrow, PopoverBody } from '@chakra-ui/react';
import { useTable, useFilters, useGlobalFilter, useSortBy, usePagination, useRowSelect } from 'react-table';
import { TRIGGER_TABLE_ONCHANGE, PAGINATE, useTableStates } from '@laliga-cdac2/state';
import { SortDescendingIcon, SortAscendingIcon, SortIcon } from '@laliga-cdac2/icons';
import Checkbox from '@laliga-cdac2/checkbox';
import { useAtom } from 'jotai';
import Button from '@laliga-cdac2/button';
import { CheckIcon } from '@chakra-ui/icons';
import { Stack, Box } from '@chakra-ui/layout';
import { AiOutlineUnorderedList } from 'react-icons/ai';
import ActivityIndicator from '@laliga-cdac2/activityindicator';
import { useTheme } from '@emotion/react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["indeterminate"];
var CheckboxColumn = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var indeterminate = _ref.indeterminate,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var defaultRef = React.useRef();
  var resolvedRef = ref || defaultRef;
  React.useEffect(function () {
    if (resolvedRef.current) {
      resolvedRef.current.indeterminate = indeterminate;
    }
  }, [resolvedRef, indeterminate]);
  return React.createElement(Checkbox, Object.assign({
    ref: resolvedRef
  }, rest));
});
var _excluded$1 = ["checked"];

var useCheckbox = function useCheckbox(hooks) {
  var _useAtom = useAtom(TRIGGER_TABLE_ONCHANGE),
      setTrigger = _useAtom[1];

  var _useAtom2 = useAtom(PAGINATE),
      paginate = _useAtom2[0];

  hooks.visibleColumns.push(function (cols) {
    return [// Columna que se encarga de la selección
    {
      id: 'selection',
      Header: function Header(_ref) {
        var getToggleAllRowsSelectedProps = _ref.getToggleAllRowsSelectedProps,
            getToggleAllPageRowsSelectedProps = _ref.getToggleAllPageRowsSelectedProps;
        return React.createElement("div", null, paginate ? React.createElement(CheckboxColumn, Object.assign({
          onClick: function onClick() {
            return setTrigger(true);
          }
        }, getToggleAllPageRowsSelectedProps())) : React.createElement(CheckboxColumn, Object.assign({
          onClick: function onClick() {
            return setTrigger(true);
          }
        }, getToggleAllRowsSelectedProps())));
      },
      Cell: function Cell(_ref2) {
        var row = _ref2.row;

        var _row$getToggleRowSele = row.getToggleRowSelectedProps(),
            checked = _row$getToggleRowSele.checked,
            rest = _objectWithoutPropertiesLoose(_row$getToggleRowSele, _excluded$1);

        return React.createElement("div", null, React.createElement(CheckboxColumn, Object.assign({
          onClick: function onClick() {
            return setTrigger(true);
          },
          defaultChecked: checked
        }, rest, {
          "data-testid": 'checkbox-column-test-id'
        })));
      }
    }].concat(cols);
  });
};

var getPropsBasedOnContentType = function getPropsBasedOnContentType(column) {
  return {
    text: {
      maxW: column.width || 'unset',
      noOfLines: column.noOfLines || 2,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word'
    },
    component: {}
  };
};

var getTdPropsBasedOnContentType = function getTdPropsBasedOnContentType(column) {
  return {
    component: {
      width: column.width || 'unset'
    },
    text: {}
  };
};
/** Escucha las propiedades definidas y emite un callback con sus cambios
 * @param {object} state - objeto con las propiedades que serán devueltas en el callback;
 * @param {func} onStateChange - callback extendido desde la prop del componente;
 */


function useOnStateChange(state, onStateChange) {
  var prevControlledState = useRef(state);
  useEffect(function () {
    if (onStateChange) {
      var prev = JSON.stringify(prevControlledState.current);
      var next = JSON.stringify(state);
      var stateChange = prev !== next;

      if (stateChange) {
        onStateChange(state);
        prevControlledState.current = state;
      }
    }
  }, [state, onStateChange]);
}

var FilterOptions = function FilterOptions(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      onChange = _ref.onChange,
      onFilterChange = _ref.onFilterChange,
      color = _ref.color;
  return React.createElement(Stack, {
    bg: "corporateGrey.100",
    pos: "absolute",
    top: "3",
    left: "0",
    zIndex: "modal",
    borderRadius: "md",
    boxShadow: "md",
    padding: "2",
    spacing: "5",
    maxH: "96",
    overflowY: "scroll"
  }, options.map(function (option) {
    var enabled = option.enabled === undefined || option.enabled;
    return React.createElement(Box, {
      key: option.key,
      d: "flex",
      justifyContent: "start",
      alignItems: "center",
      w: "full",
      padding: "10px 20px",
      fontWeight: "bold",
      borderRadius: "md",
      curpor: "pointer",
      color: enabled ? 'white' : 'corporateBlack.500',
      bg: enabled ? color + ".500" : 'none',
      cursor: "pointer",
      whiteSpace: "nowrap",
      onClick: function onClick(e) {
        e.stopPropagation();
        var newList = columns.map(function (current) {
          return current.key === option.key && _extends({}, current, {
            enabled: !enabled
          }) || current;
        });
        onChange == null ? void 0 : onChange(newList);
        onFilterChange == null ? void 0 : onFilterChange(option, newList);
      },
      "data-testid": option.Header + "-filter-test-id"
    }, enabled && React.createElement(CheckIcon, {
      mr: "2"
    }) || React.createElement("div", null), option.Header);
  }));
};

var ColumnFilter = function ColumnFilter(_ref) {
  var columns = _ref.columns,
      onChange = _ref.onChange,
      toFilter = _ref.toFilter,
      onFilterChange = _ref.onFilterChange,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'corporateBlue' : _ref$color;

  var _useState = useState(false),
      filtersVisible = _useState[0],
      setFiltersVisible = _useState[1];

  var ref = React.useRef();
  useOutsideClick({
    ref: ref,
    handler: function handler() {
      return setFiltersVisible(false);
    }
  });
  if (!columns) return null;
  return React.createElement(Stack, {
    spacing: "0",
    ref: ref
  }, React.createElement(Button, {
    onClick: function onClick(e) {
      e.stopPropagation();
      setFiltersVisible(!filtersVisible);
    },
    rightIcon: React.createElement(AiOutlineUnorderedList, null),
    disabled: filtersVisible,
    colorScheme: color
  }, "Columnas"), React.createElement(Box, {
    pos: "relative"
  }, filtersVisible && React.createElement(FilterOptions, {
    columns: columns,
    options: columns.filter(function (item) {
      if (!item.key || !item.Header) return false;
      return !Array.isArray(toFilter) || toFilter.join(' ').includes(item.key);
    }),
    onChange: onChange,
    onFilterChange: onFilterChange,
    color: color
  })));
};

var _excluded$2 = ["Cell", "label", "icon"],
    _excluded2 = ["Cell", "label", "icon"];

var TableActions = function TableActions(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      _ref$color = _ref.color,
      tableColor = _ref$color === void 0 ? 'corporateBlue' : _ref$color,
      _ref$filterProps = _ref.filterProps,
      columnFilter = _ref$filterProps.columnFilter,
      filteredColumns = _ref$filterProps.filteredColumns,
      setFilteredColumns = _ref$filterProps.setFilteredColumns,
      onColumnFilter = _ref$filterProps.onColumnFilter;
  if (!(actions != null && actions.length) && !columnFilter) return null;
  var leftActions = actions.filter(function (_ref2) {
    var _ref2$align = _ref2.align,
        align = _ref2$align === void 0 ? 'right' : _ref2$align;
    return align === 'left';
  });
  var rightActions = actions.filter(function (_ref3) {
    var _ref3$align = _ref3.align,
        align = _ref3$align === void 0 ? 'right' : _ref3$align;
    return align === 'right';
  });
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    d: "flex",
    justifyContent: "start",
    alignItems: "center",
    padding: "5",
    gridColumnGap: "2.5"
  }, columnFilter && React.createElement(ColumnFilter, {
    columns: filteredColumns,
    onChange: setFilteredColumns,
    toFilter: columnFilter,
    onFilterChange: onColumnFilter,
    color: tableColor
  }), leftActions.map(function (_ref4) {
    var Cell = _ref4.Cell,
        label = _ref4.label,
        Icon = _ref4.icon,
        props = _objectWithoutPropertiesLoose(_ref4, _excluded$2);

    if (Cell) return React.createElement(Cell, {
      key: label
    });
    return React.createElement(Button, Object.assign({
      key: label
    }, props, {
      leftIcon: Icon ? React.createElement(Icon, null) : undefined
    }), label);
  })), React.createElement(Box, {
    d: "flex",
    justifyContent: "end",
    alignItems: "center",
    padding: "5",
    gridColumnGap: "2.5"
  }, rightActions.map(function (_ref5) {
    var Cell = _ref5.Cell,
        label = _ref5.label,
        Icon = _ref5.icon,
        props = _objectWithoutPropertiesLoose(_ref5, _excluded2);

    if (Cell) return React.createElement(Cell, {
      key: label
    });
    return React.createElement(Button, Object.assign({
      key: label
    }, props, {
      leftIcon: Icon ? React.createElement(Icon, null) : undefined
    }), label);
  })));
};

var Table = function Table(props) {
  var _props$uniqueSort = props.uniqueSort,
      uniqueSort = _props$uniqueSort === void 0 ? false : _props$uniqueSort,
      _props$hoverable = props.hoverable,
      hoverable = _props$hoverable === void 0 ? true : _props$hoverable,
      _props$headProps = props.headProps,
      headProps = _props$headProps === void 0 ? {} : _props$headProps,
      _props$wrapperProps = props.wrapperProps,
      wrapperProps = _props$wrapperProps === void 0 ? {} : _props$wrapperProps,
      _props$tableProps = props.tableProps,
      tableProps = _props$tableProps === void 0 ? {} : _props$tableProps,
      _props$columns = props.columns,
      columns = _props$columns === void 0 ? [] : _props$columns,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      _props$checkeable = props.checkeable,
      checkeable = _props$checkeable === void 0 ? false : _props$checkeable,
      _props$onCheck = props.onCheck,
      onCheck = _props$onCheck === void 0 ? function () {} : _props$onCheck,
      _props$initialChecked = props.initialCheckedIds,
      initialCheckedIds = _props$initialChecked === void 0 ? [] : _props$initialChecked,
      _props$paginate = props.paginate,
      paginate = _props$paginate === void 0 ? false : _props$paginate,
      _props$pageSize = props.pageSize,
      pageSize = _props$pageSize === void 0 ? 5 : _props$pageSize,
      _props$currentPage = props.currentPage,
      currentPage = _props$currentPage === void 0 ? 0 : _props$currentPage,
      _props$sortable = props.sortable,
      sortable = _props$sortable === void 0 ? true : _props$sortable,
      _props$globalFilter = props.globalFilter,
      globalFilter = _props$globalFilter === void 0 ? null : _props$globalFilter,
      _props$onRowCountChan = props.onRowCountChange,
      onRowCountChange = _props$onRowCountChan === void 0 ? function () {} : _props$onRowCountChan,
      _props$onStateChange = props.onStateChange,
      onStateChange = _props$onStateChange === void 0 ? function () {} : _props$onStateChange,
      _props$manualSort = props.manualSort,
      manualSort = _props$manualSort === void 0 ? false : _props$manualSort,
      _props$autoResetSort = props.autoResetSort,
      autoResetSort = _props$autoResetSort === void 0 ? false : _props$autoResetSort,
      _props$onRowSelection = props.onRowSelection,
      onRowSelection = _props$onRowSelection === void 0 ? function () {} : _props$onRowSelection,
      _props$clickableRow = props.clickableRow,
      clickableRow = _props$clickableRow === void 0 ? false : _props$clickableRow,
      _props$highlightedRow = props.highlightedRowsIds,
      highlightedRowsIds = _props$highlightedRow === void 0 ? [] : _props$highlightedRow,
      highlightedRowsStyles = props.highlightedRowsStyles,
      panelWidth = props.panelWidth,
      _props$autoResetPage = props.autoResetPage,
      autoResetPage = _props$autoResetPage === void 0 ? true : _props$autoResetPage,
      _props$columnFilter = props.columnFilter,
      columnFilter = _props$columnFilter === void 0 ? false : _props$columnFilter,
      _props$onColumnFilter = props.onColumnFilter,
      onColumnFilter = _props$onColumnFilter === void 0 ? function () {} : _props$onColumnFilter,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      _props$color = props.color,
      color = _props$color === void 0 ? 'corporateBlue' : _props$color,
      _props$noDataFallBack = props.noDataFallBack,
      noDataFallBack = _props$noDataFallBack === void 0 ? 'No hay datos disponibles' : _props$noDataFallBack,
      _props$headerColumnPr = props.headerColumnProps,
      headerColumnProps = _props$headerColumnPr === void 0 ? {} : _props$headerColumnPr,
      externalFilteredColumns = props.externalFilteredColumns,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$loadingCompone = props.loadingComponent,
      loadingComponent = _props$loadingCompone === void 0 ? React.createElement(ActivityIndicator, {
    alignItems: "center",
    justifyContent: "center",
    withText: false,
    color: "corporateBlack.500"
  }) : _props$loadingCompone,
      hasDetailPanel = props.hasDetailPanel,
      titleKeyDetailRowPanel = props.titleKeyDetailRowPanel,
      titleAccesorDetailRowPanel = props.titleAccesorDetailRowPanel,
      contentKeyDetailRowPanel = props.contentKeyDetailRowPanel,
      contentAccesorDetailRowPanel = props.contentAccesorDetailRowPanel,
      fontSizeTitlePanelDetail = props.fontSizeTitlePanelDetail,
      fontSizeDescriptionPanelDetail = props.fontSizeDescriptionPanelDetail,
      titleDayPatternDetailRowPanel = props.titleDayPatternDetailRowPanel,
      contentDayPatternDetailRowPanel = props.contentDayPatternDetailRowPanel,
      onDoubleClick = props.onDoubleClick,
      selectedId = props.selectedId,
      FilterCustomChildren = props.filterCustomChildren,
      DetailPanelCustomComponent = props.detailPanelCustomComponent;
  var currentTheme = useTheme();
  var fontFamily = currentTheme.fonts.body;

  var _useTableStates = useTableStates(),
      _useTableStates$trigg = _useTableStates.trigger,
      triggerState = _useTableStates$trigg[0],
      setTrigger = _useTableStates$trigg[1],
      _useTableStates$pagin = _useTableStates.paginate,
      setPaginate = _useTableStates$pagin[1];

  var _useState = useState(undefined),
      selectedRow = _useState[0],
      setSelectedRow = _useState[1];
  /**
   * Lazy preselect row
   */


  useEffect(function () {
    setSelectedRow(selectedId);
  }, [selectedId]);

  var _useState2 = useState(),
      rowSelectedDetail = _useState2[0],
      setRowSelectedDetail = _useState2[1];

  var _useState3 = useState(columns),
      filteredColumns = _useState3[0],
      setFilteredColumns = _useState3[1];

  var initialSelectedRowsIds = useMemo(function () {
    return initialCheckedIds == null ? void 0 : initialCheckedIds.reduce(function (rows, id) {
      var _extends2;

      return _extends({}, rows, (_extends2 = {}, _extends2[id] = true, _extends2));
    }, {});
  }, [initialCheckedIds]);
  var memoizedData = useMemo(function () {
    return data; // eslint-disable-next-line
  }, [JSON.stringify(data)]);
  var memoizedColumns = useMemo(function () {
    return columns; // eslint-disable-next-line
  }, [JSON.stringify(columns), JSON.stringify(data), selectedRow]);

  var _useTable = useTable({
    columns: columnFilter || externalFilteredColumns ? filteredColumns : memoizedColumns,
    data: memoizedData,
    getRowId: function getRowId(row) {
      return row == null ? void 0 : row.id;
    },
    manualSortBy: manualSort,
    autoResetPage: autoResetPage,
    autoResetSortBy: autoResetSort,
    initialState: {
      selectedRowIds: initialSelectedRowsIds
    },
    isMultiSortEvent: function isMultiSortEvent() {
      return true;
    }
  }, useFilters, useGlobalFilter, sortable ? useSortBy : function () {}, usePagination, useRowSelect, checkeable ? useCheckbox : function (hooks) {
    return hooks;
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      rows = _useTable.rows,
      page = _useTable.page,
      prepareRow = _useTable.prepareRow,
      _useTable$state = _useTable.state,
      selectedRowIds = _useTable$state.selectedRowIds,
      sortBy = _useTable$state.sortBy,
      filters = _useTable$state.filters,
      hiddenColumns = _useTable$state.hiddenColumns,
      setPageSize = _useTable.setPageSize,
      gotoPage = _useTable.gotoPage,
      setGlobalFilter = _useTable.setGlobalFilter;

  useOnStateChange({
    sortBy: sortBy,
    filters: filters,
    hiddenColumns: hiddenColumns
  }, onStateChange); // Efecto que se encarga de llamar al callback para informar sobre los nuevos checks

  useEffect(function () {
    if (!checkeable || !triggerState) return;
    var rowIds = Object.keys(selectedRowIds);
    onCheck == null ? void 0 : onCheck(rowIds);
    setTrigger(false);
  }, [checkeable, onCheck, selectedRowIds, triggerState]);
  useEffect(function () {
    // we need to set all the atoms states.
    setPaginate(!!paginate);
  }, [paginate]);
  useEffect(function () {
    // Hacemos un trim del input para evitar filtrar incorrectamente por espacios indebidos
    var trimmedFitler = globalFilter == null ? void 0 : globalFilter.trim();
    if (trimmedFitler === '') setGlobalFilter(undefined);else setGlobalFilter(trimmedFitler);
  }, [globalFilter, setGlobalFilter]);
  /* Se encarga de actualizar correctamente el tamaño de página de la paginación */

  useEffect(function () {
    if (!paginate) return;
    setPageSize(pageSize || 5);
  }, [pageSize, paginate, setPageSize]);
  /* Se encarga de actualizar correctamente la página actual de la paginación */

  useEffect(function () {
    if (!paginate) return;
    gotoPage(currentPage || 0);
  }, [currentPage, gotoPage, paginate]);
  useEffect(function () {
    onRowCountChange == null ? void 0 : onRowCountChange(rows.length);
  }, [onRowCountChange, rows]);
  useEffect(function () {
    if (externalFilteredColumns) {
      setFilteredColumns(filteredColumns.map(function (col) {
        return _extends({}, col, {
          enabled: !!col.Header ? col.key && externalFilteredColumns.includes(col.key) : undefined
        });
      }));
    }
  }, [externalFilteredColumns]);
  /* Renderiza el icono por defecto de sort para dar a entender que esa columna
  se puede ordenar */

  var renderSortIcon = function renderSortIcon(column) {
    var SortIconToRender = column.isSorted ? column.isSortedDesc ? SortDescendingIcon : SortAscendingIcon : SortIcon;
    return column.canSort ? React.createElement(SortIconToRender, {
      boxSize: "15px",
      mt: "-3px !important",
      _hover: {
        color: 'gray.500'
      }
    }) : null;
  };

  var shouldRenderActionsContainer = (actions == null ? void 0 : actions.length) || columnFilter; // Estado local que garantiza la paginación sin llamada a base de datos

  var dataToShow = paginate ? page : rows;

  var onRowClick = function onRowClick(e, row) {
    e.stopPropagation();
    var hasBeenSelected = selectedRow === row.id;

    if (clickableRow && onRowSelection) {
      onRowSelection(hasBeenSelected ? null : row);
      setSelectedRow(hasBeenSelected ? undefined : row == null ? void 0 : row.id);
    }

    if (hasDetailPanel) {
      setRowSelectedDetail(hasBeenSelected ? null : row);
    }
  };

  var onRowDoubleClick = function onRowDoubleClick(e, row) {
    e.stopPropagation();

    if (onDoubleClick) {
      onDoubleClick(row);
    }
  };

  var detailPanelProps = {
    panelWidth: panelWidth,
    rowSelectedDetail: rowSelectedDetail,
    titleKeyDetailRowPanel: titleKeyDetailRowPanel,
    titleAccesorDetailRowPanel: titleAccesorDetailRowPanel,
    contentKeyDetailRowPanel: contentKeyDetailRowPanel,
    contentAccesorDetailRowPanel: contentAccesorDetailRowPanel,
    fontSizeTitlePanelDetail: fontSizeTitlePanelDetail,
    fontSizeDescriptionPanelDetail: fontSizeDescriptionPanelDetail,
    titleDayPatternDetailRowPanel: titleDayPatternDetailRowPanel,
    contentDayPatternDetailRowPanel: contentDayPatternDetailRowPanel
  };
  return React.createElement(Stack$1, Object.assign({
    width: "full"
  }, wrapperProps), shouldRenderActionsContainer && React.createElement(Box$1, {
    d: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    w: "full"
  }, React.createElement(TableActions, {
    actions: actions,
    color: color,
    filterProps: {
      filteredColumns: filteredColumns,
      setFilteredColumns: setFilteredColumns,
      columnFilter: columnFilter,
      onColumnFilter: onColumnFilter
    }
  })), React.createElement(Box$1, {
    w: "100"
  }, FilterCustomChildren && React.createElement(React.Fragment, null, React.createElement(FilterCustomChildren, Object.assign({
    actions: actions,
    color: color,
    filterProps: {
      filteredColumns: filteredColumns,
      setFilteredColumns: setFilteredColumns,
      columnFilter: columnFilter,
      onColumnFilter: onColumnFilter
    }
  }, props)))), React.createElement(HStack, Object.assign({
    style: {
      marginTop: 0
    },
    alignItems: "flex-start",
    overflowX: "scroll",
    overflowY: "unset"
  }, wrapperProps), React.createElement(Table$1, Object.assign({
    variant: "simple"
  }, getTableProps(), tableProps), React.createElement(Thead, null, headerGroups.map(function (headerGroup) {
    return React.createElement(Tr, Object.assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.filter( // @ts-ignore
    function (header) {
      return header.enabled === undefined || header.enabled;
    }).map(function (column, _, allColumns) {
      var headerProps = column.getHeaderProps(sortable ? column.getSortByToggleProps() : '');
      return React.createElement(Th, Object.assign({}, headerProps, {
        onClick: function onClick(event) {
          if (sortable && uniqueSort) {
            allColumns.forEach(function (col) {
              return col.id !== column.id && col.isSorted && col.clearSortBy();
            });
          }

          if (headerProps != null && headerProps.onClick) {
            headerProps.onClick(event);
          }
        },
        pos: column.fixed ? 'sticky' : 'relative'
      }, column.fixed ? _extends({}, column.fixed) : {}, {
        bg: column.fixed && tableProps.colorScheme ? tableProps.colorScheme + ".50" : 'corporateGrey.50',
        zIndex: column.fixed ? 2 : undefined
      }, headProps, {
        maxW: headProps.width || headProps.w || column.width,
        fontFamily: fontFamily
      }), React.createElement(HStack, Object.assign({
        pos: "relative"
      }, headerColumnProps, {
        justifyContent: column.alignment || headerColumnProps.justifyContent || 'flex-start',
        alignItems: "center"
      }), React.createElement(Text, {
        as: "div",
        whiteSpace: "nowrap",
        "data-testid": "column-" + column.render('Header') + "-test-id"
      }, column.render('Header')), renderSortIcon(column)));
    }));
  })), isLoading && React.createElement(TableCaption, {
    textAlign: "center",
    w: "full"
  }, loadingComponent), (data == null ? void 0 : data.length) > 0 && !isLoading && React.createElement(Tbody, Object.assign({}, getTableBodyProps()), dataToShow.map(function (row) {
    var _row$id;

    prepareRow(row);
    var cells = row.cells.filter(function (_ref) {
      var column = _ref.column;
      return column.enabled === undefined || column.enabled;
    });
    return React.createElement(Tr, Object.assign({}, row.getRowProps({
      // @ts-ignore
      onClick: function onClick(e) {
        return onRowClick(e, row);
      },
      onDoubleClick: function onDoubleClick(e) {
        return onRowDoubleClick(e, row);
      }
    }), {
      cursor: clickableRow || hasDetailPanel ? 'pointer' : 'default',
      _hover: _extends({}, hoverable ? {
        bg: tableProps.colorScheme ? tableProps.colorScheme + ".50" : 'corporateGrey.50'
      } : {}),
      sx: {
        '&:hover > td': {
          bg: row.id === selectedRow ? 'rgba(0, 119, 200, 0.2)' : tableProps.colorScheme ? tableProps.colorScheme + ".50" : 'corporateGrey.50'
        }
      }
    }, highlightedRowsIds != null && highlightedRowsIds.includes((_row$id = row.id) == null ? void 0 : _row$id.toString()) ? highlightedRowsStyles : null, {
      "data-testid": "row-" + row.id + "-test-id"
    }), cells.map(function (cell, i) {
      var columnProps = getPropsBasedOnContentType(cell.column);
      var specificTdProps = getTdPropsBasedOnContentType(cell.column);
      return React.createElement(Td, Object.assign({}, cell.getCellProps(), {
        pos: cell.column.fixed ? 'sticky' : 'relative'
      }, cell.column.fixed ? _extends({}, cell.column.fixed) : {}, {
        _hover: _extends({}, hoverable ? {
          bg: row.id === selectedRow ? 'rgba(0, 119, 200, 0.2)' : tableProps.colorScheme ? tableProps.colorScheme + ".50" : 'corporateGrey.50'
        } : {}),
        bg: cell.column.fixed ? 'white' : undefined,
        zIndex: cell.column.fixed ? 2 : undefined
      }, specificTdProps[cell.render('Cell').props.value ? 'text' : 'component'], {
        sx: _extends({}, row.id === selectedRow && {
          backgroundColor: 'rgba(0, 119, 200, 0.1)'
        })
      }), React.createElement(Box$1, Object.assign({
        d: "flex",
        justifyContent: cell.column.alignment || i === cells.length - 1 && 'flex-end'
      }, columnProps[typeof cell.render('Cell').props.value === 'string' ? 'text' : 'component'], {
        onClick: function onClick(e) {
          return onRowClick(e, row);
        }
      }), cell.column.popover ? React.createElement(Popover, {
        preventOverflow: true
      }, React.createElement(PopoverTrigger, null, React.createElement(Button$1, {
        variant: "unstyled",
        minW: "unset",
        fontWeight: "normal",
        maxW: cell.column.width
      }, React.createElement(Text, {
        as: "span",
        maxW: cell.column.width,
        d: "block",
        isTruncated: true
      }, cell.render('Cell')))), React.createElement(Portal, null, React.createElement(PopoverContent, null, React.createElement(PopoverArrow, null), React.createElement(PopoverBody, null, cell.render('Cell'))))) : cell.render('Cell')));
    }));
  })), data.length <= 0 && !isLoading && React.createElement(TableCaption, {
    textAlign: "center",
    fontSize: 'xl',
    w: "full"
  }, noDataFallBack)), hasDetailPanel && rowSelectedDetail && DetailPanelCustomComponent && React.createElement(DetailPanelCustomComponent, Object.assign({}, detailPanelProps))));
};

export default Table;
export { getPropsBasedOnContentType, getTdPropsBasedOnContentType };